var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("به نرم افزار "+_vm._s(_vm.app_name)+" خوش آمدید")])])}
var staticRenderFns = []

export { render, staticRenderFns }